"use strict";
let cards = Array.from(document.querySelectorAll('.cards--selected'));
let cardActiveIcon = document.querySelector('.cards__image--checked');
let card = [...cards];
card.map((item) => {
    item.addEventListener("click", (event) => {
        event.preventDefault();
        (event) ? (cardActiveIcon.classList.contains('hidden')) ? item.classList.remove('hidden') : item.classList.add('hidden') : '';
    });
});
